<!-- eslint-disable max-len -->
<style scoped>
  .submit-form-button[title='Approve'], .submit-form-button[title='Reject'], .submit-form-button[title='Submit'] {
    margin-left: 7px;
  }
</style>
<template>
  <div class="view-contents">
    <b-overlay :show="isLoading" class='site-assessment-overlay'>
      <b-card no-body>
        <b-tabs
          card
          align="center"
        >
          <b-tab v-for="(section) in schema"
            :key="section.legend"
            :title="section.legend"
            @click="afterChange"
            class="tabbed-form-header"
          >
            <b-card-body>
              <b-alert
                :show="successDismissCountDown"
                dismissible
                variant="success"
                @dismissed="successDismissCountDown=0"
                @dismiss-count-down="successCountDownChanged"
              >
                Site Assessment has been saved
              </b-alert>
              <b-alert
                :show="warningDismissCountDown"
                dismissible
                variant="warning"
                @dismissed="warningDismissCountDown=0"
                @dismiss-count-down="warningCountDownChanged"
              >
                Site Assessment failed to save with the following error: {{ serverError }}
              </b-alert>
              <b-alert
                :show="validationAlertDismissCountDown"
                dismissible
                variant="danger"
                @dismissed="validationAlertDismissCountDown=0"
                @dismiss-count-down="validationAlertDismissCountDownChanged"
              >
                <span>'Preparer' is a required field!</span>
              </b-alert>
              <div class="row section-header">
                <div class="col-10 bold-title">
                  {{ section.headerName }}
                  <span v-if="section.headerName=='Resource Analysis'">
                    <b-button
                      v-if="isReopener && isReopenable"
                      class="submit-form-button btn-danger"
                      pill
                      variant="primary"
                      size="sm"
                      title='Reopen'
                      @click="reopenSiteAssessment">
                      <span>Reopen</span>
                    </b-button>
                    <b-button
                      v-if="isRejecter && isRejectable"
                      class="submit-form-button btn-danger"
                      pill
                      variant="primary"
                      size="sm"
                      title='Reject'
                      @click="rejectSiteAssessment">
                      <span>Reject</span>
                    </b-button>
                    <b-button
                      v-if="isApprover && isApprovable"
                      class="submit-form-button"
                      pill
                      variant="primary"
                      size="sm"
                      title='Approve'
                      @click="approveSiteAssessment">
                      <span>Approve</span>
                    </b-button>
                    <b-button
                      v-if="isSubmitter && isSubmittable"
                      v-b-modal="'submitSiteAssessmentModal'"
                      id='submitSiteAssessmentButton'
                      class="btn-danger submit-form-button"
                      pill
                      variant="primary"
                      size="sm"
                      title='Submit'
                    >
                      <span>Submit</span>
                    </b-button>
                    <b-modal id="submitSiteAssessmentModal" title="Confirm Site Assessment Submittal" @ok="submitSiteAssessmentOK">
                      <p>
                        <span>You are submitting this Site Assessment for Manager's approval.</span>
                      </p>
                      <p>
                        <span>You will not be able to make edits once submitted and you cannot revert the submission.</span>
                      </p>
                      <p>
                        <span>Are you sure you want to submit?</span>
                      </p>
                      <template v-slot:modal-footer="{ ok, cancel }">
                        <b-button size="sm" variant="danger" @click="cancel" class='btn-danger'>No</b-button>
                        <b-button size="sm" variant="success" @click="ok" class='btn-yes'>Yes</b-button>
                      </template>
                    </b-modal>
                  </span>
                  <b-button
                    v-if="!isApproved && ((isSubmitter && isEditable) || (isApprover))"
                    pill
                    variant="primary"
                    size="sm"
                    class="submit-form-button"
                    :disabled="isSubmitting"
                    @click="saveSiteAssessment">
                    Save
                  </b-button>
                </div>
              </div>
              <b-overlay :show="isApproved || !((isSubmitter && isEditable) || (isApprover))" opacity=".33">
                <VueFormGenerator
                  :schema="section"
                  :model="siteAssessmentModel"
                  :options="formOptions"
                  ref="background"
                  @model-updated="modelUpdated"
                />
                <template v-slot:overlay>
                  <div></div>
                </template>
              </b-overlay>
            </b-card-body>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-overlay>
  </div>
</template>
<script>
/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';
import AlertManager from '../mixins/AlertManager';
import AssessmentSchemaHelper from '../mixins/assessmentSchemaHelper';
import exitFormModal from '../mixins/exitFormModal';
import showSidePanelToggle from '../mixins/showSidePanelToggle';

export default {
  name: 'SiteAssessment',
  mixins: [AlertManager, AssessmentSchemaHelper, showSidePanelToggle, exitFormModal],
  data() {
    return {
      schema: [],
      isLoading: true,
      isSubmitting: false,
      siteAssessmentModel: null,
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
      },
      validationAlertDismissCountDown: 0,
    };
  },
  computed: {
    currentUser() {
      return this.$store.getters['User/getCurrentUser'];
    },
    ...mapState('SiteAssessment', {
      serverError: (state) => state.serverError,
      siteAssessment: (state) => state.siteAssessment,
      tualatinContacts: (state) => state.tualatinContacts,
    }),
    ...mapState('SiteVisit', {
      siteVisit: (state) => state.siteVisit,
    }),
    ...mapState(['currentSite']),
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    isEditable() {
      if (this.siteAssessment == null) return false;
      let returnValue = false;
      switch (this.siteAssessment.status) {
        case this.config.siteAssessmentForm.submitStatus.Started:
          returnValue = true;
          break;
        case this.config.siteAssessmentForm.submitStatus.PendingApproval:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Approved:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Rejected:
          returnValue = true;
          break;
        default:
          break;
      }
      return returnValue;
    },
    isSubmitter() {
      if (this.memberOf.length === 0) return false;
      if (!this.config.siteAssessmentForm.submitterRoles || this.config.siteAssessmentForm.submitterRoles.length === 0) return false;
      return this.memberOf.filter((item) => this.config.siteAssessmentForm.submitterRoles.includes(item.displayName)).length > 0;
    },
    isSubmittable() {
      if (this.siteAssessment == null) return false;
      let returnValue = false;
      switch (this.siteAssessment.status) {
        case this.config.siteAssessmentForm.submitStatus.Started:
          returnValue = true;
          break;
        case this.config.siteAssessmentForm.submitStatus.PendingApproval:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Approved:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Rejected:
          returnValue = true;
          break;
        default:
          break;
      }
      return returnValue;
    },
    isApproved() {
      if (this.siteAssessment == null) return false;
      return this.siteAssessment.status === this.config.siteAssessmentForm.submitStatus.Approved;
    },
    isApprover() {
      if (this.memberOf.length === 0) return false;
      if (!this.config.siteAssessmentForm.approverRoles || this.config.siteAssessmentForm.approverRoles.length === 0) return false;
      return this.memberOf.filter((item) => this.config.siteAssessmentForm.approverRoles.includes(item.displayName)).length > 0;
    },
    isApprovable() {
      if (this.siteAssessment == null) return false;
      let returnValue = false;
      switch (this.siteAssessment.status) {
        case this.config.siteAssessmentForm.submitStatus.Started:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.PendingApproval:
          returnValue = true;
          break;
        case this.config.siteAssessmentForm.submitStatus.Approved:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Rejected:
          returnValue = false;
          break;
        default:
          break;
      }
      return returnValue;
    },
    isRejecter() {
      if (this.memberOf.length === 0) return false;
      if (!this.config.siteAssessmentForm.rejecterRoles || this.config.siteAssessmentForm.rejecterRoles.length === 0) return false;
      return this.memberOf.filter((item) => this.config.siteAssessmentForm.rejecterRoles.includes(item.displayName)).length > 0;
    },
    isRejectable() {
      if (this.siteAssessment == null) return false;
      let returnValue = false;
      switch (this.siteAssessment.status) {
        case this.config.siteAssessmentForm.submitStatus.Started:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.PendingApproval:
          returnValue = true;
          break;
        case this.config.siteAssessmentForm.submitStatus.Approved:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Rejected:
          returnValue = false;
          break;
        default:
          break;
      }
      return returnValue;
    },
    isReopener() {
      if (this.memberOf.length === 0) return false;
      if (!this.config.siteAssessmentForm.reopenerRoles || this.config.siteAssessmentForm.reopenerRoles.length === 0) return false;
      const value = this.memberOf.filter((item) => this.config.siteAssessmentForm.reopenerRoles.includes(item.displayName)).length > 0;
      return value;
    },
    isReopenable() {
      if (this.siteAssessment == null) return false;
      let returnValue = false;
      switch (this.siteAssessment.status) {
        case this.config.siteAssessmentForm.submitStatus.Started:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.PendingApproval:
          returnValue = false;
          break;
        case this.config.siteAssessmentForm.submitStatus.Approved:
          returnValue = true;
          break;
        case this.config.siteAssessmentForm.submitStatus.Rejected:
          returnValue = false;
          break;
        default:
          break;
      }
      return returnValue;
    },
  },
  mounted() {
    this.$store.dispatch('Membership/fetchMemberOf');
    this.$store.dispatch('fetchSiteAsync', parseInt(this.$route.params.id, 10)).then(() => {
      this.$store.dispatch('SiteAssessment/fetchTualatinContacts').then(() => {
        this.$store.dispatch('SiteVisit/fetchSiteVisit',
          {
            currentSite: this.currentSite,
            currentUser: this.$store.getters['User/getCurrentUser'].name,
            initializeVisit: false,
          }).then(() => {
          this.$store.dispatch('SiteAssessment/fetchOrCreateSiteAssessment',
            {
              currentSiteVisit: this.siteVisit,
            }).then(() => {
            //  make a copy so we can manipulate it in the forms
            this.siteAssessmentModel = this.cloneObject(this.siteAssessment);
            if (this.siteAssessment.background.preparerId === null) {
              const contactEmail = this.currentUser.username.toLowerCase();
              const contact = this.tualatinContacts.find((e) => e.emaiL_ADDRESS.toLowerCase() === contactEmail);
              if (contact && contact !== null) {
                this.siteAssessmentModel.background.preparerId = contact.contacT_ID;
              }
            }
            this.isLoading = false;
            this.schema = this.getAssessmentSchema().groups;
          });
        });
      });
    });
  },
  methods: {
    // this should be extracted out to a mixin
    afterChange() {
      window.scrollTo(0, 0);
      return true;
    },
    approveSiteAssessment() {
      this.siteAssessmentModel.status = this.config.siteAssessmentForm.submitStatus.Approved;
      this.saveSiteAssessment();
      if (!this.serverError) {
        if (this.siteAssessmentModel.background) {
          const contact = this.tualatinContacts.find((ct) => ct.contacT_ID === this.siteAssessmentModel.background.preparerId);
          if (contact) {
            window.location.href = `mailto:${contact.emaiL_ADDRESS}?subject=Site Assessment Approved&body=${this.currentSite.RecordName}: ${window.location.href}`;
          }
        }
      }
    },
    // this should be extracted out to a mixin
    cloneObject(sourceObj) {
      const newObj = {};
      Object.assign(newObj, sourceObj);
      return newObj;
    },
    rejectSiteAssessment() {
      this.siteAssessmentModel.status = this.config.siteAssessmentForm.submitStatus.Rejected;
      this.isSubmitting = true;
      this.$store.dispatch('SiteAssessment/saveAssessment', this.siteAssessmentModel).then(() => {
        this.isSubmitting = false;
        if (this.serverError) {
          this.showWarningAlert();
        } else {
          // this is a call to the exitFormModal so it keeps track of saved/unsaved changes
          this.modelSaved();
          if (this.siteAssessment.submittedBy) {
            const link = document.createElement('a');
            link.href = `mailto:${this.siteAssessment.submittedBy}?subject=Site Assessment Rejected`;
            document.body.appendChild(link);
            link.click();
          }
        }
      });
      this.afterChange();
    },
    reopenSiteAssessment() {
      this.siteAssessmentModel.status = this.config.siteAssessmentForm.submitStatus.Started;
      this.isSubmitting = true;
      this.$store.dispatch('SiteAssessment/saveAssessment', this.siteAssessmentModel).then(() => {
        this.isSubmitting = false;
        if (this.serverError) {
          this.showWarningAlert();
        } else {
          // this is a call to the exitFormModal so it keeps track of saved/unsaved changes
          this.modelSaved();
        }
      });
      this.afterChange();
    },
    saveSiteAssessment() {
      if (this.siteAssessmentModel.background.preparerId === null) {
        this.showValidationAlert();
        return;
      }
      this.isSubmitting = true;
      this.$store.dispatch('SiteAssessment/saveAssessment', this.siteAssessmentModel).then(() => {
        this.$store.dispatch('SiteAssessment/fetchExistingSiteAssessment', parseInt(this.$route.params.id, 10)).then(() => {
          this.siteAssessmentModel = { ...this.siteAssessment };
          this.isSubmitting = false;
          if (this.serverError) {
            this.showWarningAlert();
          } else {
            // this is a call to the exitFormModal so it keeps track of saved/unsaved changes
            this.modelSaved();
            this.showSuccessAlert();
          }
        });
      });
      this.afterChange();
    },
    async submitSiteAssessmentOK() {
      if (this.siteAssessmentModel.background.preparerId === null) {
        this.showValidationAlert();
        return;
      }
      this.siteAssessmentModel.status = this.config.siteAssessmentForm.submitStatus.PendingApproval;

      this.isSubmitting = true;
      await this.$store.dispatch('SiteAssessment/saveAssessment', this.siteAssessmentModel);
      this.isSubmitting = false;

      if (this.serverError) {
        this.showWarningAlert();
      } else {
        // this is a call to the exitFormModal so it keeps track of saved/unsaved changes
        this.modelSaved();
        await this.$store.dispatch('SiteAssessment/setSubmitSuccess', true);
        this.$router.push({
          path: `/site/${this.currentSite.Id}`,
        });
      }

      this.afterChange();
    },
    validationAlertDismissCountDownChanged(validationAlertDismissCountDown) {
      this.validationAlertDismissCountDown = validationAlertDismissCountDown;
    },
    showValidationAlert() {
      this.validationAlertDismissCountDown = 10;
    },
    hideValidationAlert() {
      this.validationAlertDismissCountDown = 0;
    },
  },
};
</script>
